import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { memo, useState } from 'react';
import { MdImage, MdPictureAsPdf } from 'react-icons/md';

type TMediaThumbProps = {
  src: string;
  alt: string;
  size: number;
  fallbackColor: string;
};

export const MediaThumb = memo(function MediaThumb({ src, alt, size, fallbackColor }: TMediaThumbProps) {
  const [errored, setErrored] = useState(false);
  const isPdf = alt.toLowerCase().endsWith('.pdf');

  if (isPdf) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.75,
          background: 'linear-gradient(145deg, #fff5f5 0%, #ffe8e8 100%)',
        }}
      >
        <MdPictureAsPdf size={size * 1.5} color="#e53935" />
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.6rem',
            fontWeight: 700,
            letterSpacing: 1,
            color: '#e53935',
            textTransform: 'uppercase',
            bgcolor: 'rgba(229,57,53,0.12)',
            px: 0.75,
            py: 0.25,
            borderRadius: 0.5,
          }}
        >
          PDF
        </Typography>
      </Box>
    );
  }

  if (errored) {
    return <MdImage size={size} color={fallbackColor} />;
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
    />
  );
});
